var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check",staticStyle:{"padding-bottom":"10px"}},[_vm._l((_vm.msgList),function(item,index){return _c('p',{key:index,staticClass:"item"},[_vm._v(_vm._s(item))])}),_c('div',{staticClass:"check-btn"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.handleSure}},[_vm._v("确定")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }